
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Building } from 'lucide-react';

interface EmptyStateViewProps {
  showAsAdmin: boolean;
}

const EmptyStateView: React.FC<EmptyStateViewProps> = ({ showAsAdmin }) => {
  return (
    <div className="rounded-lg border border-dashed p-8 text-center">
      <Building className="mx-auto h-12 w-12 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-medium">No organizations found</h3>
      <p className="mt-2 text-sm text-muted-foreground">
        Start by creating your first organization.
      </p>
      <Button className="mt-4" asChild>
        <Link to="/admin/organizations">Create Organization</Link>
      </Button>
    </div>
  );
};

export default EmptyStateView;
